function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import CreatableSelect from 'react-select/creatable';
import InputTooltip from '@engine/components/presentational/base/input-tooltip';
import React from 'react';

var TagsField = /*#__PURE__*/function (_React$Component) {
  _inherits(TagsField, _React$Component);

  var _super = _createSuper(TagsField);

  function TagsField() {
    var _this;

    _classCallCheck(this, TagsField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.isValidNewOption = function (inputValue) {
      if (_this.props.isValidNewOption) {
        return _this.props.isValidNewOption(inputValue);
      }

      return true;
    };

    _this.noOptionsMessage = function (_ref) {
      var inputValue = _ref.inputValue;
      return _this.props.noOptionsMessage && _this.props.noOptionsMessage(inputValue);
    };

    return _this;
  }

  _createClass(TagsField, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("div", {
        className: "row form-group tags-field"
      }, React.createElement("div", {
        className: "col-lg-12 tags-field-label"
      }, React.createElement("label", {
        htmlFor: this.props.name
      }, this.props.label)), React.createElement("div", {
        className: this.props.fieldWidth
      }, React.createElement(CreatableSelect, {
        isMulti: true,
        isClearable: this.props.isClearable,
        isDisabled: this.props.disabled,
        backspaceRemovesValue: this.props.backspaceRemovesValue,
        placeholder: "Type to add...",
        defaultValue: this.parseCommaSeparatedOptions(),
        options: this.parseCommaSeparatedOptions(),
        id: this.props.name,
        name: this.props.name,
        onChange: function onChange(values, action) {
          _this2.props.onChange(_this2.convertToCommaSeparatedOptions(values || []), _this2.props.name, action);
        },
        isValidNewOption: this.isValidNewOption,
        noOptionsMessage: this.noOptionsMessage
      })), React.createElement(InputTooltip, {
        text: this.props.tooltip
      }));
    }
  }, {
    key: "parseCommaSeparatedOptions",
    value: function parseCommaSeparatedOptions() {
      var values = this.props.value.split(',');
      var options = [];
      values.filter(function (option) {
        return option;
      }).forEach(function (option) {
        options.push({
          value: option,
          label: option
        });
      });
      return options;
    }
  }, {
    key: "convertToCommaSeparatedOptions",
    value: function convertToCommaSeparatedOptions(values) {
      return values.map(function (option) {
        return option.value;
      }).join(',');
    }
  }]);

  return TagsField;
}(React.Component);

TagsField.defaultProps = {
  backspaceRemovesValue: true,
  disabled: false,
  value: '',
  fieldWidth: 'col-lg-6 col-md-6 col-sm-6',
  isClearable: true
};
export default TagsField;